import React from "react";
import { Navigate } from "react-router-dom";
import { useAuthStore } from "../store/useAuthStore";
import { hasAnyPermissionCode, hasPermissionCode } from "../utils/permissions";

/**
 * Gates children behind permission code(s) or a custom accessCheck.
 * Unauthorized users are sent to the full-page /404 route (no sidebar/layout).
 *
 * Use `permissionRequired` for a single code, `permissionAnyOf` for OR logic,
 * or `accessCheck={(user) => boolean}` for custom rules.
 */
const RoleBasedPermissions = ({
  children,
  permissionRequired,
  permissionAnyOf,
  accessCheck,
}) => {
  const { user, isAuthenticated } = useAuthStore();
  const hasStoredSession = !!localStorage.getItem("user");

  // No session at all → login
  if (!isAuthenticated && !hasStoredSession) {
    return <Navigate to="/login" replace />;
  }

  // Session restore still in progress
  if (!isAuthenticated || !user) {
    return null;
  }

  let allowed = false;
  if (typeof accessCheck === "function") {
    allowed = !!accessCheck(user);
  } else if (Array.isArray(permissionAnyOf) && permissionAnyOf.length > 0) {
    allowed = hasAnyPermissionCode(user, permissionAnyOf);
  } else {
    allowed = hasPermissionCode(user, permissionRequired);
  }

  if (!allowed) {
    return <Navigate to="/404" replace />;
  }

  return children;
};

export default RoleBasedPermissions;
